import React from 'react'
import { Table } from 'react-bootstrap'
import { inject, observer } from 'mobx-react'
import { t } from 'i18next'
import PositionInstances from './PositionInstances.jsx'
import styled from 'styled-components'
const StyledHeaderTr = styled.tr`
  th {
    .pending-delivery-info {
      font-size: small;
      color: gray;
      font-weight: initial;
    }
  }
`
const ResponsiveTableWrapper = styled.div`
  width: 100%;
  overflow-x: auto;

  @media only screen and (max-width: 767px),
    (min-device-width: 320px) and (max-device-width: 767px) {
    .react-bs-table-no-data {
      display: none;
    }

    table {
      empty-cells: show;
      width: 100%;
    }

    thead > tr > th {
      width: 50%;
      display: inline-block;
      border: 0.5px solid gray;
      text-align: center;
    }

    .fullWidthMobile {
      width: 100%;
      display: inline-block;
    }

    tbody,
    td,
    tr {
      display: block;
    }

    th::after {
      display: none;
    }

    tr:nth-child(2n) {
      background: #ccc;
    }

    td {
      border: none;
      border-bottom: 1px solid #eee;
      empty-cells: show !important;
      position: relative;
      white-space: normal;
      text-align: left;
    }

    td::before {
      position: absolute;
      top: 6px;
      left: 6px;
      width: 44%;
      white-space: nowrap;
      text-align: left;
      font-weight: bold;
    }

    .actions-header-cell,
    .checkBox-header-cell {
      display: none;
    }

    .actions-cell {
      width: 100% !important;
    }
  }
`

const PositionInstancesList = inject('productsStore')(
    observer((props) => {
        const { productsStore } = props
        const basket = productsStore.basket ? productsStore.basket : {}
        const articles = basket.articles ? basket.articles : []
        return (
            <>
                <ResponsiveTableWrapper>
                    <Table borderless>
                        <tbody>
                            {articles.map((article) => {
                                if (!article.article.useSerialKeys && !article.article.useBatchKeys && !article.article.useRFIDs) {
                                    return null
                                }
                                return (
                                    <React.Fragment key={article.id}>
                                        {/*<tr>*/}
                                        <StyledHeaderTr>
                                            <th>{t('name')}</th>
                                            <th>{t('inventory:articleNr')}</th>
                                            <th>{t('size')}</th>
                                            <th>{t('quantity')}</th>
                                            {/*</tr>*/}
                                        </StyledHeaderTr>
                                        {article.positions.map((position) => {
                                            return (
                                                <PositionInstances
                                                    key={`${article.id}_${position.articleVariant
                                                        ? position.articleVariant.id
                                                        : '_'
                                                        }`}
                                                    article={article}
                                                    position={position}
                                                />
                                            )
                                        })}
                                    </React.Fragment>
                                )
                            })}
                        </tbody>
                    </Table>
                </ResponsiveTableWrapper>
            </>
        )
    })
)

export default PositionInstancesList
